import { SelectInput } from 'canoe';
import { Field, FieldAttributes, useFormikContext } from 'formik';
import React, { useMemo } from 'react';

import { Filter, FilterOperations, FilterOperationsEnglishNames, FilterTypes } from './types';

const filterTypes = Object.entries(FilterOperationsEnglishNames).map(([key, value]) => ({
  value: key,
  label: value,
}));

const contentAndSegmentTypes = [
  FilterOperations.Equals,
  FilterOperations.EqualsNot,
  FilterOperations.OneOf,
  FilterOperations.NotOneOf,
];

export const OperationTypeSelector = () => {
  const { values, setFieldValue } = useFormikContext<Filter>();

  const filteredTypes = useMemo(() => {
    if (values.type === FilterTypes.ContentId || values.type === FilterTypes.SegmentId) {
      return filterTypes.filter((item) =>
        contentAndSegmentTypes.includes(item.value as FilterOperations),
      );
    }

    if (values.type === FilterTypes.Host || values.type === FilterTypes.Pathname) {
      return filterTypes.filter(
        (item) => item.value !== FilterOperations.OneOf && item.value !== FilterOperations.NotOneOf,
      );
    }

    return filterTypes;
  }, [values.type]);

  return (
    <Field name="operation.type">
      {({ field }: FieldAttributes<any>) => (
        <SelectInput
          {...field}
          items={filteredTypes}
          selectedItem={filterTypes.find((i) => i.value === values.operation.type)}
          clearable={false}
          onSelect={(item: any) => setFieldValue('operation.type', item.value, false)}
        />
      )}
    </Field>
  );
};
